export const citySlides = [
  {
    image: "/cities/prague.webp",
    alt: "Prague",
  },
  {
    image: "/cities/paris.webp",
    alt: "Paris",
  },
  {
    image: "/cities/london.webp",
    alt: "London",
  },
  {
    image: "/cities/lviv2.webp",
    alt: "Lviv",
  },
  {
    image: "/cities/berlin.webp",
    alt: "Berlin",
  },
  {
    image: "/cities/rome.webp",
    alt: "Rome",
  },
  {
    image: "/cities/krakow.webp",
    alt: "Krakow",
  },
];
